import React, { Fragment, ReactElement } from "react";
import './NewProjectWizardPage.scss';

interface NewProjectWizardStepNumberProps {
    stepNum: number;
    isComplete: boolean;
    isActive: boolean;
    stepName: string;
    stepDescription: string;
    isFinalStep?: boolean;
}

const NewProjectWizardStepNumber = ({
    stepNum,
    isComplete,
    isActive,
    stepName,
    stepDescription,
    isFinalStep = false
}: NewProjectWizardStepNumberProps): ReactElement => {

    const renderNumberIcon = () => {
        if (isComplete)
            return '';
        else
            return stepNum;
    };

    const getClassName = () => {
        if (isComplete)
            return 'success';
        else if (isActive)
            return 'active';
        else
            return 'inactive';
    };

    return (
        <Fragment>
            <div className="wizard-step-number-container">
                <div className={'wizard-step-number-' + getClassName()}>{renderNumberIcon()}</div>
                <div className='wizard-step-line'>
                    {!isFinalStep && <div>&nbsp;</div>}
                </div>
            </div>
            <div className={'wizard-step-text-' + getClassName()}>
                <h6>{stepName}</h6>
                <p>{stepDescription}</p>
            </div>
        </Fragment>
    );
};

export default NewProjectWizardStepNumber;
